import { partsApi } from './parts';

export const itemDescriptionsApi = partsApi.injectEndpoints({
    endpoints: (builder) => ({
getBlockShelfSeqItemDescriptions: builder.query({
    query: (params = {}) => {
        const queryParams = {
            PageNumber: params.pageNumber ?? 1,
            PageSize: params.pageSize ?? 10,
            IsActive: params.isActive ?? params.IsActive ?? 1,
            LanguageId: params.languageId ?? params.LanguageId ?? 2,
            ...(params.searchText && { SearchText: params.searchText }),
            ...(params.partCode && { PartCode: params.partCode }),
            ...(params.partDesc && { PartDesc: params.partDesc })
        };

        params.filters?.forEach((filter, index) => {
            queryParams[`Filters[${index}].Column`] = filter.column;
            queryParams[`Filters[${index}].Operator`] = filter.operator;
            queryParams[`Filters[${index}].Value`] = filter.value;
        });

        params.sorts?.forEach((sort, index) => {
            queryParams[`Sorts[${index}].Column`] = sort.column;
            queryParams[`Sorts[${index}].Direction`] = sort.direction;
        });
                return {
                    url: 'v1/itemdescriptions/shelf-item-description-list',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                const data = response?.data ?? response;
                const items = data?.items ?? data?.Items ?? [];
                const totalCount =
                    data?.totalCount ??
                    data?.TotalCount ??
                    (Array.isArray(items) ? items.length : 0);

                return {
                    items: Array.isArray(items) ? items : [],
                    totalCount: Number(totalCount) || 0
                };
            },
            providesTags: (result) =>
                result?.items
                    ? [
                          ...result.items.map(({ id }) => ({
                              type: 'ItemDescription',
                              id
                          })),
                          { type: 'ItemDescription', id: 'LIST' }
                      ]
                    : [{ type: 'ItemDescription', id: 'LIST' }]
        }),

        exportBlockShelfSeqItemDescriptionsToExcel: builder.query({
                query: (body = {}) => ({
                    url: '/v1/itemdescriptions/shelf-item-description-exporttoexcel',
                    method: 'POST',
                    body: {
                        filters: body?.filters ?? null,
                        sorts: body?.sorts ?? null,
                        compressionType: 0
                    }
                }),
                transformResponse: (response) => {
                    if (response?.isSuccessful && response?.data) {
                        return response.data;
                    }

                    return {
                        fileBase64: null,
                        error: true
                    };
                }
        }),

        createBlockShelfSeqItemDescription: builder.mutation({
            query: (data) => ({
                url: 'v1/itemdescriptions/shelf-item-description-add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'ItemDescription', id: 'LIST' }]
        }),
        updateBlockShelfSeqItemDescription: builder.mutation({
            query: (data) => ({
                url: 'v1/itemdescriptions/shelf-item-description-update',
                method: 'PATCH',
                body: data
            }),
            invalidatesTags: [{ type: 'ItemDescription', id: 'LIST' }]
        }),
        deleteBlockShelfSeqItemDescription: builder.mutation({
            query: (data) => ({
                url: 'v1/itemdescriptions/shelf-item-description-delete',
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: [{ type: 'ItemDescription', id: 'LIST' }]
        })
    }),
    overrideExisting: false
});

export const {
    useGetBlockShelfSeqItemDescriptionsQuery,
    useLazyExportBlockShelfSeqItemDescriptionsToExcelQuery,
    useCreateBlockShelfSeqItemDescriptionMutation,
    useUpdateBlockShelfSeqItemDescriptionMutation,
    useDeleteBlockShelfSeqItemDescriptionMutation
} = itemDescriptionsApi;